(function () {
  if (window.ShippingProgressLoaded) return;
  window.ShippingProgressLoaded = true;

  var REFRESH_EVENT = 'shipping-progress:refresh';
  var CART_URL_PATTERN = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  // Notify every bar when anything on the page changes the cart.
  var originalFetch = window.fetch;
  if (originalFetch) {
    window.fetch = function () {
      var args = arguments;
      var request = originalFetch.apply(this, args);
      try {
        var target = args[0];
        var url = typeof target === 'string' ? target : target && target.url;
        if (url && CART_URL_PATTERN.test(url)) {
          request
            .then(function () {
              document.dispatchEvent(new CustomEvent(REFRESH_EVENT));
            })
            .catch(function () {});
        }
      } catch (error) {}
      return request;
    };
  }

  var pendingCart = null;
  function fetchCart(cartUrl) {
    if (!pendingCart) {
      pendingCart = originalFetch(cartUrl + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (response) {
          return response.json();
        })
        .finally(function () {
          pendingCart = null;
        });
    }
    return pendingCart;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  var moneyFormatter = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
  function formatMoney(cents) {
    return moneyFormatter.format(Math.max(0, cents) / 100);
  }

  // ---- Black Friday tiers ----------------------------------------------
  var BF_PREVIEW_KEY = 'sp-bf-preview';
  (function readPreviewParam() {
    try {
      var param = new URLSearchParams(window.location.search).get('bf_preview');
      if (param === '1') window.sessionStorage.setItem(BF_PREVIEW_KEY, '1');
      if (param === '0') window.sessionStorage.removeItem(BF_PREVIEW_KEY);
    } catch (error) {}
  })();

  function bfPreviewOn() {
    try {
      return window.sessionStorage.getItem(BF_PREVIEW_KEY) === '1';
    } catch (error) {
      return false;
    }
  }

  // Today's date in UK time as YYYY-MM-DD.
  function ukToday() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/London',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).formatToParts(new Date());
      var map = {};
      parts.forEach(function (part) {
        map[part.type] = part.value;
      });
      return map.year + '-' + map.month + '-' + map.day;
    } catch (error) {
      return null;
    }
  }

  var DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
  function bfActive(bf) {
    if (!bf) return false;
    if (bf.editorPreview || bfPreviewOn()) return true;
    if (!bf.enabled || !DATE_PATTERN.test(bf.start || '') || !DATE_PATTERN.test(bf.end || '')) return false;
    var today = ukToday();
    return !!today && today >= bf.start && today <= bf.end;
  }

  // Shared cache of whether each product (by handle) carries the discount tag.
  var tagCache = {};
  var tagRequests = {};
  function loadTagged(handle, tag) {
    if (Object.prototype.hasOwnProperty.call(tagCache, handle)) return Promise.resolve(tagCache[handle]);
    if (!tagRequests[handle]) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      tagRequests[handle] = originalFetch(root + 'products/' + encodeURIComponent(handle) + '.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Product not found');
          return response.json();
        })
        .then(function (product) {
          var tags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',');
          tagCache[handle] = tags.some(function (t) {
            return String(t).trim().toLowerCase() === tag;
          });
          return tagCache[handle];
        })
        .catch(function () {
          tagCache[handle] = false;
          return false;
        })
        .finally(function () {
          delete tagRequests[handle];
        });
    }
    return tagRequests[handle];
  }

  function readJson(element, selector, fallback) {
    var node = element.querySelector(selector);
    if (!node) return fallback;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return fallback;
    }
  }

  class ShippingProgress extends HTMLElement {
    connectedCallback() {
      this.config = readJson(this, '[data-sp-config]', null);
      if (!this.config) return;
      this.suggestions = readJson(this, '[data-sp-suggestions]', null);
      this.excluded = new Set((this.config.excluded || []).map(String));
      this.reachedFinal = null;
      this.renderToken = 0;

      var seeded = (this.config.bf && this.config.bf.tagged) || {};
      Object.keys(seeded).forEach(function (handle) {
        if (!Object.prototype.hasOwnProperty.call(tagCache, handle)) tagCache[handle] = !!seeded[handle];
      });

      this.text = this.querySelector('.shipping-progress__text');
      this.track = this.querySelector('.shipping-progress__track');
      this.fill = this.querySelector('.shipping-progress__fill');
      this.lead = this.querySelector('.shipping-progress__lead-star');
      this.goalStar = this.querySelector('.shipping-progress__goal-star');
      this.note = this.querySelector('.shipping-progress__note');
      this.goalPath = this.goalStar && this.goalStar.querySelector('path');
      this.suggestionsWrap = this.querySelector('.shipping-progress__suggestions');
      this.suggestionsList = this.querySelector('.shipping-progress__suggestions-list');
      this.errorEl = this.querySelector('.shipping-progress__error');

      var initialCart = readJson(this, '[data-sp-cart]', null);
      if (initialCart) this.render(initialCart);

      this.onRefresh = this.refresh.bind(this);
      document.addEventListener(REFRESH_EVENT, this.onRefresh);
      this.onPageShow = this.refresh.bind(this);
      window.addEventListener('pageshow', this.onPageShow);
    }

    disconnectedCallback() {
      if (this.onRefresh) document.removeEventListener(REFRESH_EVENT, this.onRefresh);
      if (this.onPageShow) window.removeEventListener('pageshow', this.onPageShow);
    }

    refresh() {
      var self = this;
      fetchCart(this.dataset.cartUrl || '/cart')
        .then(function (cart) {
          self.render(cart);
        })
        .catch(function () {});
    }

    message(key, amountCents, messages) {
      var template = escapeHtml((messages || this.config.messages)[key] || '');
      if (amountCents == null) return template;
      return template.split('[amount]').join('<strong>' + escapeHtml(formatMoney(amountCents)) + '</strong>');
    }

    render(cart) {
      var token = ++this.renderToken;
      var bf = this.config.bf;
      if (!bfActive(bf)) {
        this.renderStandard(cart);
        return;
      }

      var self = this;
      var tag = bf.tag || 'disc';
      var unknown = (cart.items || [])
        .map(function (item) {
          return item.handle;
        })
        .filter(function (handle, index, list) {
          return handle && list.indexOf(handle) === index && !Object.prototype.hasOwnProperty.call(tagCache, handle);
        });

      if (!unknown.length) {
        this.renderBlackFriday(cart);
        return;
      }

      Promise.all(
        unknown.map(function (handle) {
          return loadTagged(handle, tag);
        })
      ).then(function () {
        if (token === self.renderToken) self.renderBlackFriday(cart);
      });
    }

    renderBlackFriday(cart) {
      var bf = this.config.bf;
      var messages = bf.messages || {};
      var goal1 = this.config.goal1;
      var goal2 = bf.goal2;
      var goal3 = bf.goal3;
      // Free delivery uses the whole basket, as normal.
      var subtotal = cart.total_price || 0;
      // Discount tiers count only tagged products, at their price before discounts.
      var eligible = (cart.items || []).reduce(function (sum, item) {
        return tagCache[item.handle] ? sum + (item.original_line_price || 0) : sum;
      }, 0);
      // Mixed basket: something in it doesn't count towards the offers.
      var mixed = (cart.items || []).some(function (item) {
        return !tagCache[item.handle];
      });
      var suffix = mixed ? 'Mixed' : '';
      var pick = function (key) {
        return mixed && messages[key + suffix] ? key + suffix : key;
      };

      var state = { remaining: null, reachedFinal: false, showNote: mixed };
      if (subtotal < goal1) {
        state.remaining = goal1 - subtotal;
        state.html = this.message('far', state.remaining, messages);
        state.percent = (subtotal / goal1) * 100;
      } else if (eligible < goal2) {
        state.html = this.message(pick('goal1'), goal2 - eligible, messages);
        state.percent = (eligible / goal2) * 100;
      } else if (eligible < goal3) {
        state.html = this.message(pick('goal2'), goal3 - eligible, messages);
        state.percent = (eligible / goal3) * 100;
      } else {
        state.html = this.message(pick('goal3'), null, messages);
        state.percent = 100;
        state.reachedFinal = true;
      }

      this.applyState(cart, state);
    }

    renderStandard(cart) {
      var goal1 = this.config.goal1;
      var goal2 = this.config.goal2;
      var subtotal = cart.total_price || 0;
      var excluded = this.excluded;
      var excludedTotal = (cart.items || []).reduce(function (sum, item) {
        return excluded.has(String(item.product_id)) ? sum + (item.final_line_price || 0) : sum;
      }, 0);
      var eligible = Math.max(0, subtotal - excludedTotal);

      var html;
      var percent;
      var reachedFinal = false;
      var remaining = null;

      if (!cart.item_count) {
        html = this.message('empty');
        percent = 0;
      } else if (subtotal < goal1) {
        remaining = goal1 - subtotal;
        html = this.message(remaining <= this.config.close ? 'close' : 'far', remaining);
        percent = (subtotal / goal1) * 100;
      } else if (eligible < goal2) {
        html = this.message('goal1', goal2 - eligible);
        percent = (eligible / goal2) * 100;
      } else {
        html = this.message('goal2');
        percent = 100;
        reachedFinal = true;
      }

      this.applyState(cart, { html: html, percent: percent, reachedFinal: reachedFinal, remaining: remaining });
    }

    applyState(cart, state) {
      var html = state.html;
      var reachedFinal = state.reachedFinal;
      var remaining = state.remaining;
      var percent = Math.max(0, Math.min(100, state.percent));
      if (this.note) this.note.hidden = !state.showNote || !this.note.textContent.trim();
      this.text.innerHTML = html;
      this.fill.style.width = percent + '%';
      this.lead.style.left = percent + '%';
      this.track.setAttribute('aria-valuenow', Math.round(percent));

      if (this.goalPath) {
        if (reachedFinal) {
          this.goalPath.setAttribute('fill', '#3F6B64');
          this.goalPath.setAttribute('stroke', 'none');
        } else {
          this.goalPath.setAttribute('fill', 'none');
          this.goalPath.setAttribute('stroke', '#3F6B64');
        }
      }

      if (reachedFinal && this.reachedFinal === false) this.pop();
      if (remaining === null && this.lastRemaining != null && cart.item_count) this.pop();
      this.reachedFinal = reachedFinal;
      this.lastRemaining = remaining;

      this.renderSuggestions(cart, remaining);
    }

    pop() {
      var star = this.goalStar;
      if (!star) return;
      star.classList.remove('is-popping');
      void star.getBoundingClientRect();
      star.classList.add('is-popping');
      setTimeout(function () {
        star.classList.remove('is-popping');
      }, 450);
    }

    renderSuggestions(cart, remaining) {
      if (!this.suggestionsWrap || !Array.isArray(this.suggestions)) return;
      if (remaining === null || !cart.item_count) {
        this.suggestionsWrap.hidden = true;
        return;
      }

      var inCart = new Set((cart.items || []).map(function (item) {
        return String(item.product_id);
      }));

      var picks = this.suggestions
        .filter(function (item) {
          return !inCart.has(String(item.productId));
        })
        .map(function (item, index) {
          var distance = item.price >= remaining ? item.price - remaining : (remaining - item.price) * 2;
          if (item.best) distance = distance * 0.8;
          return { item: item, score: distance, index: index };
        })
        .sort(function (a, b) {
          return a.score - b.score || a.index - b.index;
        })
        .slice(0, 3)
        .map(function (entry) {
          return entry.item;
        });

      if (!picks.length) {
        this.suggestionsWrap.hidden = true;
        return;
      }

      var addLabel = escapeHtml(this.config.addLabel || '+ Add');
      this.suggestionsList.innerHTML = picks
        .map(function (item) {
          var image = item.image
            ? '<img src="' + escapeHtml(item.image) + '" alt="" width="56" height="56" loading="lazy">'
            : '';
          return (
            '<li class="shipping-progress__suggestion">' +
            '<a class="shipping-progress__suggestion-image" href="' + escapeHtml(item.url) + '" tabindex="-1" aria-hidden="true">' + image + '</a>' +
            '<div class="shipping-progress__suggestion-info">' +
            '<a class="shipping-progress__suggestion-name" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a>' +
            '<span class="shipping-progress__suggestion-price">' + escapeHtml(formatMoney(item.price)) + '</span>' +
            '</div>' +
            '<button type="button" class="shipping-progress__add" data-variant-id="' + item.variantId + '" aria-label="' + addLabel + ' ' + escapeHtml(item.title) + '">' + addLabel + '</button>' +
            '</li>'
          );
        })
        .join('');

      var self = this;
      this.suggestionsList.querySelectorAll('.shipping-progress__add').forEach(function (button) {
        button.addEventListener('click', function () {
          self.addToCart(button);
        });
      });

      if (this.errorEl) this.errorEl.hidden = true;
      this.suggestionsWrap.hidden = false;
    }

    addToCart(button) {
      var self = this;
      button.disabled = true;

      var cartItems = document.querySelector('cart-items');
      var sections =
        cartItems && typeof cartItems.getSectionsToRender === 'function' ? cartItems.getSectionsToRender() : [];
      var body = { items: [{ id: Number(button.dataset.variantId), quantity: 1 }] };
      if (sections.length) {
        body.sections = sections.map(function (section) {
          return section.section;
        });
        body.sections_url = window.location.pathname;
      }

      window
        .fetch((this.dataset.cartAddUrl || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify(body),
        })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok || data.status) throw new Error(data.description || data.message || 'Error');
            return data;
          });
        })
        .then(function (data) {
          if (data.sections && cartItems) {
            sections.forEach(function (section) {
              var wrapper = document.getElementById(section.id);
              var html = data.sections[section.section];
              if (!wrapper || !html) return;
              var target = wrapper.querySelector(section.selector) || wrapper;
              var parsed = new DOMParser().parseFromString(html, 'text/html');
              var source = parsed.querySelector(section.selector);
              if (source) target.innerHTML = source.innerHTML;
            });
            var footer = document.getElementById('main-cart-footer');
            cartItems.classList.remove('is-empty');
            if (footer) footer.classList.remove('is-empty');
          }
        })
        .catch(function (error) {
          button.disabled = false;
          if (self.errorEl) {
            self.errorEl.textContent = error.message;
            self.errorEl.hidden = false;
          }
        });
    }
  }

  if (!customElements.get('shipping-progress')) {
    customElements.define('shipping-progress', ShippingProgress);
  }
})();
